import {TabPanel} from "@atlaskit/tabs";
import type {ComponentProps} from "react";

export function AnankeTabPanel(props: ComponentProps<typeof TabPanel>) {
    return <TabPanel {...props} />;
}
